import React, { useMemo } from 'react';

import { Box } from '@mui/material';

import {
  NO_TEMPLATE_LABEL,
  PreviewKind,
  TemplateChangeKind,
  TemplateRequestStatus,
} from '../../FormChangeHistory.constants';
import { TemplateChangesetPropTypes } from '../../FormChangeHistory.propTypes';
import { changesetStyles } from '../../FormChangeHistory.styles';
import { getChangePreviewPanes, getPrismSidePresence } from '../../FormChangeHistory.utils';
import useTemplateChanges from '../../hooks/useTemplateChanges';
import PrismTemplateParts from '../PrismTemplateParts';
import TemplatePreviewAction from '../TemplatePreviewAction';
import TemplateRequestState from '../TemplateRequestState';

/**
 * The `forms.prismTemplate` renderer: the change's Prism parts, read from `template-changes` when
 * the row's changes are shown, and the way to see both sides rendered with the parts marked.
 */
const PrismTemplateChangeset = ({ change, detail }) => {
  const { auditId, status, data, retry } = useTemplateChanges({ change, detail });

  const previewPanes = useMemo(
    () => getChangePreviewPanes(getPrismSidePresence(change.summary.data)),
    [change],
  );

  if (status !== TemplateRequestStatus.LOADED) {
    return (
      <Box sx={changesetStyles}>
        <TemplateRequestState emptyLabel={NO_TEMPLATE_LABEL} status={status} onRetry={retry} />
      </Box>
    );
  }

  return (
    <>
      <TemplatePreviewAction
        auditId={auditId}
        isHidden={data.kind !== TemplateChangeKind.PRISM}
        kind={PreviewKind.CHANGE}
        occurredAtUtc={detail.summary.occurredAtUtc ?? null}
        panes={previewPanes}
        parts={data.parts ?? null}
        templateKind={TemplateChangeKind.PRISM}
      />
      <PrismTemplateParts templateChanges={data} />
    </>
  );
};

PrismTemplateChangeset.propTypes = TemplateChangesetPropTypes;

export default PrismTemplateChangeset;
